import { render, staticRenderFns } from "./BodyAnatomyTypeForm.vue?vue&type=template&id=22640029&scoped=true&"
import script from "./BodyAnatomyTypeForm.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22640029",
  null
  
)

export default component.exports